import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './App';

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// Иконка для кнопки
const LockIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-lock-fill"
        viewBox="0 0 16 16"
        style={{ marginRight: '8px' }}
    >
        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
    </svg>
);

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        window.location.href = 'https://monolit-admin.ru';
      }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Отправляемые данные:', { username, password });
        try {
            const response = await fetch(`${PATH_TO_BACKEND}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
                credentials: 'include', // Включаем куки в запрос
            });
            const data = await response.json();
            console.log('Ответ сервера:', data);
            if (data.success) {
                login(data.user);
                navigate('/adminka/', { replace: true });
            } else {
                setError(data.error || 'Ошибка входа');
            }
        } catch (err) {
            setError('Ошибка сервера');
            console.error('Ошибка запроса:', err);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <h2 className="login-title">Вход в админ-панель</h2>
                    {error && <div className="login-error">{error}</div>}
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="username">Логин</label>
                            <input
                                id="username"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="Введите ваш логин"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Пароль</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Введите ваш пароль"
                            />
                        </div>
                        <button type="submit" className="login-button">
                            <LockIcon />
                            Войти
                        </button>
                    </form>
                </div>
            </div>

            {/* Стили */}
            <style jsx>{`
                .login-page {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    background: linear-gradient(135deg, #6e8efb, #a777e3);
                    padding: 20px;
                    overflow: hidden;
                }

                .login-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    max-width: 400px;
                }

                .login-card {
                    background: #ffffff;
                    border-radius: 15px;
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
                    padding: 40px 30px;
                    width: 100%;
                    animation: fadeIn 0.5s ease-in-out;
                }

                .login-title {
                    font-size: 24px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                    margin-bottom: 20px;
                }

                .login-error {
                    background-color: #f8d7da;
                    color: #721c24;
                    padding: 10px 15px;
                    border-radius: 8px;
                    margin-bottom: 20px;
                    text-align: center;
                    font-size: 14px;
                }

                .login-form {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .form-group label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #555;
                }

                .form-group input {
                    padding: 12px 15px;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    font-size: 16px;
                    color: #333;
                    transition: border-color 0.3s ease, box-shadow 0.3s ease;
                }

                .form-group input:focus {
                    outline: none;
                    border-color: #6e8efb;
                    box-shadow: 0 0 0 3px rgba(110, 142, 251, 0.1);
                }

                .form-group input::placeholder {
                    color: #aaa;
                    font-size: 14px;
                }

                .login-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 12px;
                    background: linear-gradient(135deg, #6e8efb, #a777e3);
                    color: #fff;
                    border: none;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .login-button:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(110, 142, 251, 0.3);
                }

                .login-button:active {
                    transform: translateY(0);
                    box-shadow: 0 2px 8px rgba(110, 142, 251, 0.2);
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
            `}</style>
        </div>
    );
};

export default LoginPage;